/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import type {
    Certificate,
} from 'ajs/modules/security/factories/certificates/certificate.item.factory';

import './ssl-certificate-grid-name-column.component.less';

/**
 * @description Ssl Certificate Grid Name Column.
 *
 * @author Manideep Kotha, Shahab Hashmi
 */

@Component({
    selector: 'ssl-certificate-grid-name-column',
    templateUrl: './ssl-certificate-grid-name-column.component.html',
})
export class SslCertificateGridNameColumnComponent implements OnInit {
    /**
     * Certificate Item.
     */
    @Input()
    public certificate: Certificate;

    /**
     * Name of the missing certificate issuer name.
     */
    public missingCertIssuerName: string;

    /** @override */
    public ngOnInit(): void {
        this.missingCertIssuerName = this.certificate.getMissingCertIssuerName();
    }
}
